import { createSafeContext } from "app/presentation/utils/createSafeContext";

export const [TimelineContext, useTimelineContext] = createSafeContext(
    "useTimelineContext must be used within TimelineProvider"
);
